import $ from 'jquery';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { BrowserRouter as Router, Link, Redirect, Route, Switch } from "react-router-dom";
import ReactDOMServer from 'react-dom/server';

import pwdhelpscrn from '../../images/pwdhelpscrn.png';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import PreLoginPage from '../../views/core/PreLoginPage';
import Contactus from '../../views/login/Contactus';
import CreateNewAccountForm from '../../views/login/CreateNewAccountForm';

import UnifiedForgotPwd from '../../views/login/UnifiedForgotPwd';
import ContestForgotPwd from '../../views/login/ContestForgotPwd';
import LoginForm from '../../views/login/LoginForm';

import UnifiedLogin from '../../views/login/UnifiedLogin';
import SignupForm from '../../views/login/SignupForm';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';

import '../../css/prelogin/all-css.css';
import '../../css/prelogin/main.css';
import '../../css/prelogin/wrapper.css';
import '../../css/prelogin/seo-optimize.css';
import '../../css/prelogin/App.css';

import ContestPrelogin from '../../views/registration/ContestPrelogin';
import ContestLogin from '../../views/registration/ContestLogin';

import BrowserUtil from '../../util/BrowserUtil';

import ComponentRegistry from '../../model/ComponentRegistry';
import Registration from '../../views/registration/Registration';
import ContestHome from '../../views/contest/ContestHome';
import ContestLayout from '../../views/contest/ContestLayout';
import ContestSteps from '../../views/contest/ContestSteps';
import ContestDownloads from '../../views/contest/ContestDownloads';
import ContestReport from '../../views/contest/ContestReport';
import ContestFaq from '../../views/contest/ContestFaq';
import ContestProfileSettings from '../../views/contest/ContestProfileSettings';
import ContestInstruction from '../../views/contest/ContestInstruction';
import SchoolReport from '../../views/contest/SchoolReport';

import UserStorageUtil from '../../util/UserStorageUtil';
import sidebar_props from '../../model/AppConstants.js';
import HmEventRegistry from '../../model/HmEventRegistry';

import WeeklyChallengeInstruction from '../../views/contest/WeeklyChallengeInstruction';

let maintenanceMessage = (window.maintenanceMessage) ? window.maintenanceMessage : {};


class PreloginHome extends PreLoginPage {

	constructor(props) {
		super(props);

		var urlSplitArray = document.location.pathname.split("/");

		this.state = {
			grades: [],
			classes: {},
			products_details: {},
			products_class: {},
			products_classification: {},
			products_category: {},
			products_category_order:[],
			menuOpen: false,
			isOpen:false,
			HelpModalShow:false,
			HelpModalContent:"",
			"ModalShow":false,
			"ModalContent":"",
			"ModalHeader":"",
			PLPloggedIn:false,
			LumosloggedIn:false,
			loggedIn:false,
			selectedTarriffID:null,
			purchaseKey:"PLP_USER_PURCHASE",
			customClass:"",
			userRole:"",
			navigationKey:"PLP_Navigation",
			
			
			
			userName:"",
			preloginClassName:"PreLogin",
			imagePreviewUrl:"",
			imageLoaded:false,
			userProdReqComplete:false,
			triedFree:false,
			purchased:false,
			loginRequestComplete:false,
			isHeaderAvailable:true
		}
		this.showLoginForm = this.showLoginForm.bind(this);		
		this.hideLoginModal = this.hideLoginModal.bind(this);
		this.hideHelpLoginModal = this.hideHelpLoginModal.bind(this);
	//this.loginIframeLoaded = this.loginIframeLoaded.bind(this);
	//this.pwdIframeLoaded = this.pwdIframeLoaded.bind(this);
	this.loginIframeView = null;
	this.pwdIframeView = null;	
	this.selectedMenu = null;

	this.suppressedHeaders = [];
	this.showSubscriptionForm = this.showSubscriptionForm.bind(this);
	
	this.showForgotPasswordForm = this.showForgotPasswordForm.bind(this);
	this.ContestForgotPwdForm = this.ContestForgotPwdForm.bind(this);
	this.showSuccessForgotPwdMessage = this.showSuccessForgotPwdMessage.bind(this);
	this.showSuccessContactMessage = this.showSuccessContactMessage.bind(this);
	this.showsuccessRegisterMsg = this.showsuccessRegisterMsg.bind(this);

	this.showCreateAccount = this.showCreateAccount.bind(this);
	this.showForgotHelpScreen = this.showForgotHelpScreen.bind(this);
	this.showContactus = this.showContactus.bind(this);
	
	this.showSignUp = this.showSignUp.bind(this);
	
	this.showSubScripeLoginForm = this.showSubScripeLoginForm.bind(this);
	this.getSubScripeLoginForm = this.getSubScripeLoginForm.bind(this);
	this.getSingleLoginForm = this.getSingleLoginForm.bind(this);
	this.onLogout = this.onLogout.bind(this);
	this.doLogout = this.doLogout.bind(this);
	this.menuSelected = this.menuSelected.bind(this);
	
	
	this.RIRegistration = this.RIRegistration.bind(this);
	
	this.getBannerContent = this.getBannerContent.bind(this);
	this.getBannerContentAsString = this.getBannerContentAsString.bind(this);
	this.closeBanner = this.closeBanner.bind(this);
	this.showNewLoginForm = this.showNewLoginForm.bind(this);
	this.showContestLoginForm = this.showContestLoginForm.bind(this);
	this.UpdateProfileImage = this.UpdateProfileImage.bind(this);
	this.userNameUpdateEvent = this.userNameUpdateEvent.bind(this);
	this.doPLPLogout = this.doPLPLogout.bind(this);
	this.doLumosLogout = this.doLumosLogout.bind(this);
	this.doCommonLogout = this.doCommonLogout.bind(this);
	this.gaFrom = "";
	
	this.isProdcutLoadCalled = false;
	this.modalcloseDataGA = "";

	
	
	this.postLoginTchr = this.postLoginTchr.bind(this);
	this.postLoginTchrTab = this.postLoginTchrTab.bind(this);
	this.showlog_Form_route=this.showlog_Form_route.bind(this);
	this.setPreloginClass = this.setPreloginClass.bind(this);
	this.postLoginCallBack = this.postLoginCallBack.bind(this);
	this.getSettingsView = this.getSettingsView.bind(this);

	this.getHeaderLogo = this.getHeaderLogo.bind(this);
	this.isHeaderAvailableFn = this.isHeaderAvailableFn.bind(this);

	this.getContestGroupIds = this.getContestGroupIds.bind(this);
	this.getValidContestGrp = this.getValidContestGrp.bind(this);
	this.goToDefaultContest = this.goToDefaultContest.bind(this);

	this.goToInstructions = this.goToInstructions.bind(this);
	
	this.selectedCompName = null;

	this.showHideLeftMenu = this.showHideLeftMenu.bind(this);

	this.redirectURL = "";
}

bindWindowFn(){
	window.fireLogin = this.loginFormOnLoad.bind(this);
	window.loadBanner = this.getBannerContentAsString.bind(this);
}

postLoginCallBack(){
	this.setState({PLPloggedIn:true,loggedIn:true});
}

/**
* IMPORTANT: This is only for Third party inclusions like optin monster, Freshchat etc.
* Not applicable for MS/Contest or any other custom child components
*/
initThirdPartyLibs(){
	
}

getSchoolId(){
	return this.getUser().getSchoolId();
}

handleStateChange (state) {
	this.setState({menuOpen: state.isOpen})  
}

closeMenu () {
	this.setState({menuOpen: false})
}
getBannerContent(){
	if(maintenanceMessage.showBanner){
		return(
			<div className="maintenance-banner-container">
			<div className="maintenance-banner flex-row justify-center">
			<div className="banner-icon flex-col justify-center"><i className="fa fa-exclamation-circle" aria-hidden="true"></i></div>
			<div className="maintenance-banner-content flex flex-col justify-center">
			<h3 className="title">{maintenanceMessage.bannerMessage.title}</h3>
			<p className="message">{maintenanceMessage.bannerMessage.content}</p>
			<div className="banner-close" onClick={this.closeBanner}><i className="fa fa-times" aria-hidden="true"></i></div>
			</div>
			</div>
			</div>
			);	
		}
	}

	getBannerContentAsString(){
		if(maintenanceMessage.showBanner){
			return ReactDOMServer.renderToStaticMarkup(
			<div className="maintenance-banner-container">
			<div className="maintenance-banner flex-row justify-center">
			<div className="banner-icon flex-col justify-center"><i className="fa fa-exclamation-circle" aria-hidden="true"></i></div>
			<div className="maintenance-banner-content flex flex-col justify-center">
			<h3 className="title">{maintenanceMessage.bannerMessage.title}</h3>
			<p className="message">{maintenanceMessage.bannerMessage.content}</p>
			<div className="banner-close" onClick={this.closeBanner}><i className="fa fa-times" aria-hidden="true"></i></div>
			</div>
			</div>
			</div>
			);	
		}
	}

	closeBanner(){
		var bannerContainer = document.getElementsByClassName("maintenance-banner-container");
		bannerContainer[0].style.display = "none";
	}

	menuSelected(event){
		var target = event.currentTarget;
		$(".heyMenu").removeClass("selected");
		var selectedclass = $(target).attr("data-classname");
		//console.log(selectedclass, target);
		$("."+selectedclass).addClass("selected");
		this.closeMenu();
		this.setState({preloginClassName:"PreLogin"});
	}
	showSettings (event) {
		event.preventDefault();
	}  

	preLoginLandingCss(){
		let pathName  = window.location.pathname;
		let addprelogincss = window.addprelogincss || []
		if(addprelogincss && addprelogincss.length > 0){
			for(let i=0; i<addprelogincss.length; i++){
				if(pathName.match(addprelogincss[i])){
					return true;
				}
			}
		}
		return false;
	}
	
	componentWillMount(){		 
		this.PLPSessionCheck();
		this.LumosSessionCheck();
		//console.log(this.props.location.pathname);
		if(this.preLoginLandingCss(this.props.location.pathname) || (this.props.location.pathname).indexOf("/scorecard") > -1){
	      //if(this.props.location.pathname == "/landing" || this.props.location.pathname == "/dashboard" || this.props.location.pathname == "/settings" || this.props.location.pathname == "/report" || this.props.location.pathname == "/admin" || (this.props.location.pathname).indexOf("/scorecard") > -1){
	      	this.setState({preloginClassName:"PreLoginLanding"});
	      }else{
	      	this.setState({preloginClassName:"PreLogin"});
	      }

	      this.bindWindowFn();
	  }
	  setPreloginClass(){
	  	this.setState({preloginClassName:"PreLogin"});
	  }
	  userNameUpdateEvent(username){	
		//console.log("username updated ",username);
		this.setState({userName:username});
	}
	UpdateProfileImage(imageUrl){
	  //console.log("updateimage in home::"+imageUrl);
	  if(imageUrl){
	  	this.setState({imagePreviewUrl:imageUrl, imageLoaded:true});
	  }else{
	  	this.setState({imageLoaded:false});
	  }
	}
	loadCurrentImage(){
	  //alert("loadCurrentImage....");
	  var me = this;
	  var success = function(response){
	  	if(response && response.imgUrl){
	  		me.setState({imagePreviewUrl:response.imgUrl, imageLoaded:true});
	  	}
	  } 

	  var failure = function(err){

	  }

	  new HmAjax(this.getUrlFor("PROFILE_PIC")).get(success, failure);
	}
	PLPSessionCheck(){	
		
		var me = this;
		var user_Success = function(userObj){	
			//console.log("session check succes....");
			if(typeof userObj === "object" && userObj.authToken){
				me.getUser().store(userObj);

				me.setState({PLPloggedIn:true,loginRequestComplete:true,userRole:userObj.userRole.role,userName:userObj.userName});
				if(me.headerComponent){
					me.setLoginState(true);
				}
				me.loadCurrentImage();
				me.showlog_Form_route();
				/*if(userObj.userRole.role == "STU"){
					me.props.history.push('/landing');
				}*/				
				
			}else{
				me.setState({PLPloggedIn:false,loginRequestComplete:true});
				me.setLoginState(false);	
				me.showlog_Form_route();			
			}
			
			me.detectGmailGExists();
		}

		var user_Failure = function(error){
			me.setState({PLPloggedIn:false,loginRequestComplete:true});
			me.showlog_Form_route();
			me.setLoginState(false);
			try{
				BrowserStorageUtil.removeItem(me.state.purchaseKey);
			}catch(e){
				if(console)
					console.error(e);
			}	
			
			me.detectGmailGExists();
		}		
		
		me.sessionCheck(user_Success,user_Failure);
	} 	
	LumosSessionCheck(){	
		
		var me = this;
		let authProviderId = this.getUser().getAuthProviderId();
		var user_Success = function(userObj){	
			if(typeof userObj === "object" && userObj.sessionValid){
				me.setState({LumosloggedIn:true,loginRequestComplete:true});
				me.showlog_Form_route();			
				//console.log("LumosloggedIn ",me.state.LumosloggedIn);
				let lumosRedirect = true;

				if(window.lumos_allowed_routes && window.lumos_allowed_routes.length > 0){
					for(var i=0;i<window.lumos_allowed_routes.length;i++){
						if(window.location.href && window.location.href.match(window.lumos_allowed_routes[i])){
							lumosRedirect = false;
							break;
						}
					}
				}

				/*if(window.lumos_restricted_routes && window.lumos_restricted_routes.length > 0){
					for(var i=0;i<window.lumos_restricted_routes.length;i++){
						if(window.location.href && window.location.href.match(window.lumos_restricted_routes[i])){
							lumosRedirect = true;
							break;
						}
					}
				}*/

				if(lumosRedirect && authProviderId === 5){
					//For a Lumos User, always redirect him to Lumos Page
					window.location.href = me.getUrlFor("LUMOS_REDIRECT_URL");		
				}
			}else{
				me.setState({LumosloggedIn:false,loginRequestComplete:true});
				me.showlog_Form_route();
			}
		}

		var user_Failure = function(error){
			me.setState({LumosloggedIn:false,loginRequestComplete:true});
			me.showlog_Form_route();
		}		
		new NativeAjax(this.getUrlFor("LUMOS_SESSION_CHECK")).enableCORS().get(user_Success,user_Failure);		
	} 
	setLoginState(isLoggedIn){
		this.setState({loggedIn:isLoggedIn});
	}
	hideHelpLoginModal(){
		this.setState({"HelpModalShow":false});
	}
	hideLoginModal(){
		this.setState({"ModalShow":false,customClass:""});
	}
	showForgotHelpScreen(){		
		this.setState({"HelpModalShow":true,"HelpModalContent":this.getPwdHelpContent(),customClass:"resetpasword"});
	}
	showSignupForm(loginType,userInput,gaFrom){
		this.gaFrom = gaFrom;
		this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(loginType,userInput),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
	}
	showNewLoginForm(loginType,userInput,gaFrom){
		this.gaFrom = gaFrom;
		//this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(loginType,userInput),"ModalHeader":"logo", customClass:"newloginDialog"});
		this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(loginType,userInput),"ModalHeader":"logo", customClass:"newloginDialog"});
	}
	showContestLoginForm(loginType,userInput,gaFrom){
		this.gaFrom = gaFrom;
		//this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(loginType,userInput),"ModalHeader":"logo", customClass:"newloginDialog"});
		this.setState({"ModalShow":true,"ModalContent":this.getContestLoginForm(loginType,userInput),"ModalHeader":"logo", customClass:"contestloginDialog"});
	}
	
	
	showCreateAccount(navigateurl=null,freetrail=null,gaFrom=""){
		this.gaFrom = gaFrom;
		this.modalcloseDataGA = "Home - Users who have independently registered - Sign Up - New User - Start Learning - Close";
		this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(null,null,navigateurl,freetrail),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog teacherJoinForm"});
	}
	showForgotPasswordForm(source){
		let mycustomclass="";
		this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Forgot Password";
		if(source == "plp"){
			this.modalcloseDataGA = "Home - Sign in - Users who have independently registered - Forgot Password";
			mycustomclass = "resetpasword newloginDialog contestloginDialog";
		}else{
			mycustomclass = "resetpasword newloginDialog contestloginDialog";
		}
		this.setState({"ModalShow":true,"ModalContent":this.getForgotPassword(source),"ModalHeader":this.rb("rpwd.title"),customClass:mycustomclass});
	}

	ContestForgotPwdForm(source="contest"){
		let mycustomclass="";
		this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Forgot Password";
		if(source == "contest"){
			this.modalcloseDataGA = "Home - Sign in - Users who have independently registered - Forgot Password";
			mycustomclass = "resetpasword newloginDialog contestloginDialog";
		}else{
			mycustomclass = "resetpasword newloginDialog contestloginDialog";
		}
		this.setState({"ModalShow":true,"ModalContent":this.getContestForgotPwd(source),"ModalHeader":this.rb("rpwd.title"),customClass:mycustomclass});
	}

	getPwdHelpContent(){
		return ( 
			<div id="loginRoot">
			<div className="container">
			<div className="col-12 josefin">
			<div className="loginHeaderTxt">For Parent Account:</div> 
			<div>Please use the email address you used to register with HeyMath!</div>
			<br />
			<div className="loginHeaderTxt">For Student Account:</div> 							
			<div className="mt-10">If you have not updated your email address in your Settings, please use the parent email address that was used to register with HeyMath!</div>
			<div className="mt-10">If you have updated your email address in your account settings (as shown below), please use that email ID to reset your password.</div>
			<br />
			<div>
			<img src={pwdhelpscrn}/>
			</div>
			<br />							
			</div>	
			</div>	
			</div>	
			);
		}
		
		showSubscriptionForm(callBack){
			let me = this;
			let success = function(resp){
				me.setState({"ModalShow":false});
				if(typeof callBack === "function"){
					callBack();
				}

			}

			this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginFormWithoutNav(null,null,null,null,success),"ModalHeader":"logo", customClass:"newloginDialog"});
		}


		showSubscriptionForm_deprecated(productObj){
			var purchaseObj = {
				tariffId:productObj.tariffId,
				productId:productObj.productId
			}
			BrowserStorageUtil.storeItem(this.state.purchaseKey, JSON.stringify(purchaseObj));

			var gradeid = "";
			var category = "";
			var freetrail = "";
			try{
				gradeid = productObj.gradeid;
				category = productObj.productCategory;
				freetrail = false; //productObj.freetrail;

				var tarrrifid = productObj.tariffId;
				var productid = productObj.productId;
				var buyagain = productObj.buyagain;
				

				var trackObj = {
					"grade_id": gradeid.length > 0 ? parseInt(gradeid) : null,
					"product_type": category,
					"tariff_id":tarrrifid
				}

				this.storeTrackEvent("purchase_viewed", trackObj);

			}catch(e){}
			
			try{
				if(!gradeid && localStorage.getItem("product") && localStorage.getItem("product").length > 0){
					let _prodId = localStorage.getItem("product");
					if(_prodId){
						let _tempProdDetails = JSON.parse(localStorage.getItem("proDetail"));
						
						gradeid = _tempProdDetails[_prodId].productOrigin || "";
						
						if(gradeid && gradeid.length > 0){
							localStorage.setItem("grade",gradeid);
						}
					}
				}else{
					gradeid = "";
				}
			}catch(e){
				gradeid = "";
			}
			
			if(this.state.PLPloggedIn == true){
				if(freetrail === "true"){
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-btn-click"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-freetrial-btn"});
				}else{
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-btn-click"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-subscribe-btn"});
				}

				this.setState({selectedTarriffID:productObj.tarrifid});
				// if(buyagain && buyagain == "true"){
				// 	window.location.href = '/product-details/';
				// }else{
				// 	this.props.history.push('/product-details/');
				// }
			}else{
				if(freetrail === "true"){
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-loginform"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-freetrial-btn"});
				}else{
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-loginform"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-subscribe-btn"});
				}

				this.modalcloseDataGA = "Home - Sign in - Subscription - close";
				this.setState({"ModalShow":true,"ModalContent":this.getSubScripeLoginForm(freetrail),"ModalHeader":"logo",selectedTarriffID:productObj.tarrifid,customClass:"newloginDialog"});
			}			
			
		}






		showSubScripeLoginForm(event){
			var purchaseObj = {
				tarrrifid:event.currentTarget.dataset.tarrifid,
				productid:event.currentTarget.dataset.productid
			}
			BrowserStorageUtil.storeItem(this.state.purchaseKey, JSON.stringify(purchaseObj));

			var gradeid = "";
			var category = "";
			var freetrail = "";
			try{
				gradeid = event.currentTarget.dataset.gradeid;
				category = event.currentTarget.dataset.category;
				freetrail = event.currentTarget.dataset.freetrail;

				var tarrrifid = event.currentTarget.dataset.tarrifid;
				var productid = event.currentTarget.dataset.productid;
				var buyagain = event.currentTarget.dataset.buyagain;
				

				var trackObj = {
					"grade_id": gradeid.length > 0 ? parseInt(gradeid) : null,
					"product_type": category,
					"tariff_id":tarrrifid
				}

				this.storeTrackEvent("purchase_viewed", trackObj);

			}catch(e){}
			
			try{
				if(!gradeid && localStorage.getItem("product") && localStorage.getItem("product").length > 0){
					let _prodId = localStorage.getItem("product");
					if(_prodId){
						let _tempProdDetails = JSON.parse(localStorage.getItem("proDetail"));
						
						gradeid = _tempProdDetails[_prodId].productOrigin || "";
						
						if(gradeid && gradeid.length > 0){
							localStorage.setItem("grade",gradeid);
						}
					}
				}else{
					gradeid = "";
				}
			}catch(e){
				gradeid = "";
			}
			
			if(this.state.PLPloggedIn == true){
				if(freetrail === "true"){
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-btn-click"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-freetrial-btn"});
				}else{
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-btn-click"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-subscribe-btn"});
				}

				this.setState({selectedTarriffID:event.currentTarget.dataset.tarrifid});
				if(buyagain && buyagain == "true"){
					window.location.href = '/product-details/';
				}else{
					this.props.history.push('/product-details/');
				}
			}else{
				if(freetrail === "true"){
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-loginform"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-freetrial-btn"});
				}else{
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-loginform"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-subscribe-btn"});
				}

				this.modalcloseDataGA = "Home - Sign in - Subscription - close";
				this.setState({"ModalShow":true,"ModalContent":this.getSubScripeLoginForm(freetrail),"ModalHeader":"logo",selectedTarriffID:event.currentTarget.dataset.tarrifid,customClass:"newloginDialog"});
			}
			
			
		}

		showLoginForm(e){
		//alert("showLoginForm"+this.state.LumosloggedIn+" : "+this.state.PLPloggedIn);
		if(this.state.LumosloggedIn == true || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)){
			window.top.location.href = this.getUrlFor("LUMOS_REDIRECT_URL");
		}else if(this.state.PLPloggedIn == true || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5)){

			if(this.getRouteHelper().getUrl()){
				window.top.location.href = this.getRouteHelper().getUrl();
			}else if(this.getLastAccessedView()){
				window.top.location.href = this.getLastAccessedView();
			}else if(this.allProductsExpired()){
				window.top.location.href = '/landing';                          
			}else if(!this.productsAvailableToAccess()){
				window.top.location.href = '/landing';
			}else{
				window.top.location.href = '/landing';  
			}
		} 
		else{
			
			this.getSingleLoginForm(e)
		}
	}

	allProductsExpired(){
		var productsInHistory = false;

		var user = this.getUser();
		if(user != null){
			var productsAvailable = this.productsAvailableToAccess();

			var entlHistory = user.getEntlHistory();
			if(entlHistory != null && Object.keys(entlHistory).length > 0){
				for(var i in entlHistory){
					if(entlHistory[i] != null){
						var totalLevel = entlHistory[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0){
							productsInHistory = true;
							break;
						}
					}
				}
			}

		}

		return (productsInHistory && !productsAvailable);
	}

	productsAvailableToAccess(){
		var user = this.getUser();
		if(user != null){
			var permissions = user.getPermissions();
			if(permissions != null && Object.keys(permissions).length > 0){
				for(var i in permissions){
					if(permissions[i] != null){
						var totalLevel = permissions[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0){
							return true;
						}
					}
				}
			}
		}

		return false;
	}
	showSignUp(loginType,userInput,gaFrom){
			//console.log("loginType::",loginType," userInput::",userInput);
			this.gaFrom = gaFrom;
			this.showSignupForm(loginType,userInput,gaFrom);
		}
		
		
		getUserRole(){
			var role='';
			if(this.UserStore){
				if(this.getUser() && this.getUser().get()){
					role = this.getUser().get().userRole.role;
				} 
			}
			return role;
		}

		showContactus(){
			this.modalcloseDataGA = "Footer - Contact Us - Close";
			this.setState({"ModalShow":true,"ModalContent":this.getContactusForm(),"ModalHeader":this.rb("contactus.title"), customClass:"contactus"});
		}
		showSuccessContactMessage(msg){
			this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("contactus.title"), customClass:"contactus"});
		}
		showSuccessForgotPwdMessage(msg){
			this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("rpwd.title")});
		}
		showsuccessRegisterMsg(msg){
			this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("login.createnewaccount")});
		}
		getSuccessPwdMsg(msg){
			return(
				<div className="successPwdMsg text-center">{ReactHtmlParser(msg)}</div>
				);
			}
			renderModalHeader(){
				if(this.state.ModalHeader != "logo"){
					if(this.state.customClass == "resetpasword"){
						return (<div><div className="text-center loginHeaderTxt josefinsansFont">{this.state.ModalHeader} <i className="material-icons" onClick={this.showForgotHelpScreen}>info</i></div></div>);
					}else{
						return (<div><div className="text-center loginHeaderTxt josefinsansFont">{this.state.ModalHeader}</div></div>);
					}
				}else{
					//return (<img src={heymathlogo} className="heymathlogo" width="120"/>);
				}
			}
			getCreateAccount(){
				return(
					<CreateNewAccountForm myProps={this.props} successRegisterMsg={this.showsuccessRegisterMsg} navigateURL="/product-details" />
					);
			}
			getVerifyAccount(loginType=null,userInput=null,navigateurl=null,freetrail=null){
				if(navigateurl == null){
					navigateurl = "/products";
				}
			//console.log("calling signup this.gaFrom:::",this.gaFrom);
			return(				
				<SignupForm signupUser={'student'} myProps={this.props} loginType={loginType} userInput={userInput} successRegisterMsg={this.showsuccessRegisterMsg} navigateURL={navigateurl} freetrail={freetrail} gaFrom={this.gaFrom} />
				);
		}
		
		getContactusForm(){
			return ( 
				<div>					
				<div className="row">									
				<div className="col-12 nopadding">
				<Contactus myProps={this.props} successContactus={this.showSuccessContactMessage}/>
				</div>

				</div>
				</div>
				);
			}

			getSubScripeLoginForm(freetrail){
				return ( 
				<div>					
				<div className="row">									
				<div className="col-12 nopadding">
				<UnifiedLogin myProps={this.props} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/product-details"  freetrail={freetrail}/>			
				</div>

				</div>
				</div>
				);
			}

			getContestLoginForm(loginType=null,userid=null,errMsg=null){
				return ( 
				<div>                   
				<div className="row">                                   
				<div className="col-12 nopadding">
				<ContestLogin myProps={this.props} loginType={loginType} userid={userid} callbackForgotPwd={this.ContestForgotPwdForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/products" errMsg={errMsg}  showContestLoginForm={this.showContestLoginForm}/>
				</div>
				<br/>
				</div>
				</div>
				);
			}

			getSingleLoginForm(event){
				let loginSource = event.currentTarget.dataset.source || '';

				if(!loginSource || loginSource == "lumos" || loginSource == "plp"){
					this.modalcloseDataGA = "Home - Users who have independently registered - Close";
					this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo", customClass:"newloginDialog"});
				}else if(loginSource == "contest"){
					this.modalcloseDataGA = "Home - Contest users - Close";
					this.setState({"ModalShow":true,"ModalContent":this.getContestLoginForm(),"ModalHeader":"logo", customClass:"contestloginDialog"});
				}else if(loginSource == "register"){
					this.modalcloseDataGA = "Home - Sign in - Users who want to register - Close";
					this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
				}			
			}

			loginFormOnLoad(source, redirectIfLoggedIn){

				/**
				* IMPORTANT: Certain scenarios where loginForm access has to be blocked
				*/
				if(window.accessBlocked){
					return;
				}

				if(this.state.loggedIn || this.state.LumosloggedIn || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5) || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)){
					if(redirectIfLoggedIn && (this.state.loggedIn || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5)) && this.getRouteHelper().getUrl()){
						window.location.href = this.getRouteHelper().getUrl();
						return;
					}else if(this.state.LumosloggedIn){
						window.location.href = this.getUrlFor("LUMOS_REDIRECT_URL");
						return;
					}
				}

				// if(!source || source == "contest"){
			// 	this.modalcloseDataGA = "Home - Contest users - Close";
			// 	this.setState({"ModalShow":true,"ModalContent":this.getContestLoginForm(),"ModalHeader":"logo", customClass:"contestloginDialog"});
			// }else if(source == "plp" || source == "lumos"){
			// 	this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Close";
			// 	this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo", customClass:"loginlumos"});
			// }else if(source == "register"){
			// 	this.modalcloseDataGA = "Home - Sign in - Users who want to register - Close";
			// 	this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
			// }
			this.modalcloseDataGA = "Home - Contest users - Close";
			this.setState({"ModalShow":true,"ModalContent":this.getContestLoginForm(),"ModalHeader":"logo", customClass:"contestloginDialog"});
		}

		getUnifiedLoginForm(loginType=null,userid=null,errMsg=null){
			return ( 
				<div>                   
				<div className="row">                                   
				<div className="col-12 nopadding">
				<UnifiedLogin myProps={this.props} loginType={loginType} userid={userid} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/products" errMsg={errMsg}/>
				</div>
				<br/>
				</div>
				</div>
				);
		}

		getUnifiedLoginFormWithoutNav(loginType=null,userid=null,errMsg=null, navUrl = null, callBack=null){
			return ( 
				<div>                   
				<div className="row">                                   
				<div className="col-12 nopadding">
				<UnifiedLogin myProps={this.props} loginType={loginType} userid={userid} callBack={callBack} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL={navUrl} errMsg={errMsg}/>
				</div>
				<br/>
				</div>
				</div>
				);
		}

		getPLPLoginForm(loginType=null,userid=null,errMsg=null){
			return ( 
				<div>					
				<div className="row">									
				<div className="col-12 nopadding">
				<LoginForm myProps={this.props} loginType={loginType} userid={userid} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/products" errMsg={errMsg}/>
				</div>
				<br/>
				</div>
				</div>
				);
		}
		getFreeTrialPLPLoginForm(){
			return ( 
				<div>					
				<div className="row">									
				<div className="col-12 nopadding">
			{/* <LoginForm myProps={this.props} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/products"/> */}
			<UnifiedLogin myProps={this.props} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/products"/>
			</div>
			<br/>
			</div>
			</div>
			);
		}


		getForgotPassword(source){
			return ( 
				<div>                   
				<div className="row">
				<div className="col-12 nopadding">
				<UnifiedForgotPwd myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage} showNewLoginForm={this.showNewLoginForm}/>
				</div>      
				</div>
				</div>
				);
			}

			getContestForgotPwd(source="contest"){
				return ( 
				<div>                   
				<div className="row">
				<div className="col-12 nopadding">
				<ContestForgotPwd myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage} showNewLoginForm={this.showContestLoginForm}/>
				</div>      
				</div>
				</div>
				);
			}

			getButtonName(){
				//console.log("lumos login::::",this.state.LumosloggedIn);
				if(this.state.loggedIn || this.state.LumosloggedIn || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5) || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)){
					return this.rb("btn.label.myheymath");
				}
				return this.rb("btn.label.signin");
			}

			getMargin(){
				if(this.state.loggedIn == false){
					if(this.state.LumosloggedIn){
						return "";
					}
					return "mt-7";
				}else{			
					return "";
				}
			}
			getErrorPage(){
				window.top.location.href="/404";
			}
			onLogout(){
				var me = this;

				var msg = me.rb("logout.msg");
				var buttons = [
				{
					label: me.rb("alert.ok"),
					handler: () => { me.doLogout() }
				},
				{
					label: me.rb("alert.cancel"),
					handler: () => { }
				}
				]

				me.showAlert(" ", msg, buttons);
			}
			doLumosLogout(){
				var me = this;
		//console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
		$.ajax({
			url: me.getUrlFor("LUMOS_LOGOUT"),	            
			type: 'GET',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){	            	
				me.setState({LumosloggedIn:false});	
			},
			error: function(response){
				console.log("Error in LUMOS_LOGOUT",response);
				me.setState({LumosloggedIn:false});	
			}
		});
	}

	doCommonLogout(){
		
		let redirectUrl = this.getRouteHelper().getLogOutUrl(this.getUser().getAuthProviderId());
		/*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
			redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
		}else{
			redirectUrl = (this.getUrlFor("PRELOGIN_PAGE")).replace(/"/g,"");
		}*/
		if(redirectUrl){
			if(!redirectUrl.endsWith("/")){
				redirectUrl += "/";
			}
			redirectUrl += this.getContestHost() || "";
		}else{
			redirectUrl = "/" + this.getContestHost();
		}

		//Skipping the below code with above one
		/*if(!redirectUrl){
			if(!this.getUrlFor("PRELOGIN_PAGE") && this.getUrlFor("PRELOGIN_PAGE").length > 0){
				redirectUrl = redirectUrl(this.getUrlFor("PRELOGIN_PAGE")).replace(/"/g,"");
			}else if(this.getUrlFor("HEYMATH_HOME") && this.getUrlFor("HEYMATH_HOME").length > 0){
				redirectUrl = (this.getUrlFor("HEYMATH_HOME")).replace(/"/g,"");
			}	
		}*/		

		var me = this;
		var callBackSuccess = function(){

			me.initiateTrack("logout",{});

			setTimeout(function(){
				me.UserStore.clearOldUser();
				window.location.href = redirectUrl; //me.getUrlFor("PRELOGIN_PAGE");
			},500);

		}

		var PLPcallBackFailure = function(){
			window.location.href = redirectUrl; //me.getUrlFor("PRELOGIN_PAGE");
			console.error("Logout failed.");
		}

		var callBackFailure = function(response,request){
			//window.location.href = me.getUrlFor("PRELOGIN_PAGE");
			if(request.status!=403){
				console.error("Logout failed.");
				new NativeAjax(me.getUrlFor("LUMOS_COMMON_LOGOUT")).enableCORS().get(callBackSuccess, PLPcallBackFailure);
			}else{
				window.location.href = redirectUrl; // me.getUrlFor("PRELOGIN_PAGE");
			}
		}

		new NativeAjax(this.getUrlFor("PLP_COMMON_LOGOUT")).enableCORS().get(callBackSuccess, callBackFailure);
	}

	doPLPLogout(){
		var me = this;


		var callBackSuccess = function(){

			me.initiateTrack("logout",{});

			setTimeout(function(){
				me.UserStore.clearOldUser();
				window.location.href = me.getUrlFor("PRELOGIN_PAGE");
			},500);

		}

		var callBackFailure = function(){
			console.error("Logout failed.");
		}
		new HmAjax(me.getUrlFor("LOGOUT")).get(callBackSuccess,callBackFailure);
	}

	
	doLogout(){
		var me = this;

		//console.log("logout ",me.UserStore.getAuthProviderId())
		// if(me.UserStore.getAuthProviderId() === 5){
		// 	me.doLumosLogout();
		// }
		
		try{
			BrowserStorageUtil.removeSessionItem(me.state.navigationKey);
		}catch(e){
			if(console)
				console.error(e);
		}		
		//me.doPLPLogout();
		me.doCommonLogout();
	}

	getStudUserName(){
		let str = this.state.userName;
		if(this.isBrowser() || this.isTab()){
			let maxlength = 15;
			if(str.length>maxlength){
				str = (str.substring(0, maxlength));
				// str = (str.substring(0, maxlength))+"...";
			}
			return "  "+str+"  ";
		}
	}


	renderLoginView(){
		if(this.state.loggedIn == true){
 // return(<a className="pl-20 logoutIcon" href="#" onClick={() => {this.onLogout()}}><i className="material-icons">power_settings_new</i></a>);
 let lumosHidden = "";
 if(this.state.LumosloggedIn){
 	lumosHidden = "hidden";
 }

 return(
 	<div className="inlineblock">
 {/*<div className="inlineblock pr-10 usernamedisp d-md-none d-sm-none d-lg-inlineblock" title={this.state.userName}>{this.state.userName}</div>*/}

 <div className="inlineblock navbar-nav">


 <li className="nav-item dropdown">
 <div className="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
{/*<i className="material-icons md-40 useraccountelement">account_circle</i>*/}
{this.getStudUserName()}
{ this.state.imageLoaded ? <img className="material-icons md-60  usericon imgprv" src={ this.state.imagePreviewUrl} /> : <i className="material-icons md-40 useraccountelement">account_circle</i> }

</div>
<div className="dropdown-menu">

<a className={"dropdown-item " + lumosHidden} data-ga="My-Profile" href={this.getSettingsView()} ><i className="material-icons pr-16">account_circle</i> My Profile</a>
{/* {this.chooseclass()} */}
<a className="dropdown-item" data-ga="Sign out" href="#" onClick={() => {this.onLogout()}}><i className="material-icons pr-16">power_settings_new</i> Sign out</a>
</div>
</li>


</div>
</div>
);
}
}  

/**
* Since the area is hardcoded anyway, adding some more to the existing junk to prevent polluting other areas
*/
getSettingsView(){
	if(this.getEntlMatch("CONTEST|") || this.getBasePath().match("contest")){
		return "/contest/settings";
	}else{
		return "/settings";
	}
}


componentDidMount() {	 
	var me = this;
	me.showlog_Form_route();

	var callBackSuccess = function(result){
		if(result !== null){
			me.setState({
				isLoaded: true,
				grades: result.products_classification.IN.Board.CBSE.grade_order,
				classes: result.products_classification.IN.Board.CBSE.grades,
				products_class: result.products_classification.IN.Board.CBSE.grades,
				products_category: result.products_classification.IN.Board.CBSE.products_category,
				products_category_order: result.products_classification.IN.Board.CBSE.products_category_order,
				products_classification: result,

			});
		}

			//console.log("response : ", response);
		}

		var callBackFailure = function(response){
			me.setState({
				isLoaded: true,
				error:"Error in PRODUCT_CLASSIFICATION"
			});
			console.log("Error in PRODUCT_CLASSIFICATION");		
		}

		new HmAjax(this.getUrlFor("PRODUCT_CLASSIFICATION")).post(callBackSuccess,callBackFailure);		
		
		
		try{
			if(this.selectedMenu != null){
				$("."+this.selectedMenu).addClass("selected");
			}

		}catch(e){}
		
		
		if(!BrowserStorageUtil.getStoredSessionItem(this.plpTrackKey)) {
			BrowserStorageUtil.storeSessionItem(this.plpTrackKey, "[]");
		}

		this.initThirdPartyLibs();
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT"); 
	}

	showlog_Form_route(){
		var me = this;
		//console.log("loginRequestComplete ",me.state.loginRequestComplete," : ",me.state.PLPloggedIn," : ",me.state.LumosloggedIn);
		if(me.state.loginRequestComplete && !me.state.PLPloggedIn && !me.state.LumosloggedIn){
			var qryParam = me.QueryStringToJSON();
			if(qryParam["loginForm"] && qryParam["loginForm"].length > 0){
				setTimeout(() => {
					me.loginFormOnLoad(qryParam["loginForm"]);
				}, 1000);
			}
		}
		
	}

	detectGmailGExists(){
		try{
			var params = this.QueryStringToJSON();
			if(Object.keys(params).length > 0){				
				if(params.g_exists == "true" || params.g_exists == true){
					//console.log("g_exists::this.state.PLPloggedIn=="+this.state.PLPloggedIn);
					if(this.state.PLPloggedIn == false || this.state.PLPloggedIn == "false"){
						var googleErrmsg = this.rb("google.forbiden.msg");
						//this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(null,null,googleErrmsg),"ModalHeader":"logo", customClass:"newloginDialog"});
						this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(null,null,googleErrmsg),"ModalHeader":"logo", customClass:"newloginDialog"});
					}
				}				
			}

		}catch(e){}
	}
	QueryStringToJSON() {            
		try{
			var pairs = this.props.location.search.slice(1).split('&');

			var result = {};
			pairs.forEach(function(pair) {
				pair = pair.split('=');
				result[pair[0]] = decodeURIComponent(pair[1] || '');
			});

			return JSON.parse(JSON.stringify(result));
		}catch(e){}

		return {};
	}
	getGrades(){
		if(this.state.grades !== [] && this.state.grades !== undefined){
			return this.state.grades;
		}
	}

	getClasses(){
		if(this.state.classes !== [] && this.state.classes !== undefined){
			return this.state.classes;
		}
	}

	getProductsClass(){
		if(this.state.products_class !== {} && this.state.products_class !== undefined){
			return this.state.products_class;
		}
	}


	getProductsClassification(){
		if(this.state.products_classification !== {} && this.state.products_classification !== undefined){
			return this.state.products_classification;
		}
	}

	getProductsType(){
		if(this.state.products_category !== {} && this.state.products_category !== undefined){
			return this.state.products_category;
		}
	}

	getProductsTypeOrder(){
		if(this.state.products_category_order !== [] && this.state.products_category_order !== undefined){
			return this.state.products_category_order;
		}
	}

	redirectToHome(){
		let loggedIn = false;
		if(this.state.PLPloggedIn == true || (BrowserUtil && BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5)){
			if(this.getRouteHelper().getRoute()){
				this.redirectURL = this.getRouteHelper().getRoute();
				loggedIn = true;
			}else if(this.getLastAccessedView()){
				this.redirectURL = this.getLastAccessedView();
				loggedIn = true;
			}
		}
		return loggedIn;
	}
	
	
	RIRegistration() {
		this.contestGrpId = null;

		//First option - check pathName
		this.pathName = window.location.pathname;
		if(this.pathName && this.pathName.length > 1){
			try{
				this.contestGrpId = (this.pathName.includes("/")) ? this.pathName.substring(this.pathName.indexOf("/")+1,this.pathName.length) : this.pathName;
			}catch(e){
				console.error("Error occurred while processing contestGrpId from pathName: ", e);
			}
		}

		//Second option - check match props - may not work out since not received as props
		if(!this.contestGrpId){
			this.contestGrpId = (this.props.match && this.props.match.params && !isNaN(this.props.match.params.contestGrpId)) ? this.props.match.params.contestGrpId : null;
		}

		//Last option - use window.default_contest
		if(!this.contestGrpId){
			this.contestGrpId = window.default_contest;
		}

		if(localStorage){
			this.contestGrpId = (this.contestGrpId) ? this.contestGrpId.toUpperCase() : this.contestGrpId;
			localStorage.setItem("contestType",this.contestGrpId);
		}

		this.selectedCompName = "ContestPrelogin";
		this.isHeaderAvailableFn();
		
		this.selectedMenu = "menublog";

		return(
			<div>
			<ContestPrelogin/>	
			</div>
			);
		}

		postLoginTchr(userObj){
			var me = this;
			if(!userObj){
				userObj = this.getUser().get();
			}

			if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR") {
				return (
				<ul className="textAlignLeft">
				<li><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
				</ul>	
				);
			}
		}
		postLoginTchrTab(userObj){
			var me = this;
			if(!userObj){
				userObj = this.getUser().get();
			}

			if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR") {
				return (
				<ul className="textAlignLeft">
				<li><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
				</ul>	
				);
			}else{ 
				return (
				<ul className="textAlignLeft">
				<li className="animated"><Link className="heyMenu menuproducts" data-classname="menuproducts" to="/products" onClick={() => this.menuSelected()}>Students</Link></li>
				</ul>
				);
			}
		}

		contestPreModel(path,contestType=null){
			if(localStorage){
				contestType = this.getValidContestGrp(localStorage.getItem("contestType"));					
				
				localStorage.setItem("contestType",contestType.toUpperCase());	
			}

			if(path && contestType && path.match(/:.+\?/)){
				path = path.replace(/:.+\?/, contestType);
			}else if(path && contestType && !path.match(contestType)){
				path += (path.endsWith("/")) ? contestType : ("/" + contestType);
			}
		
			return path;
		}

		getValidContestGrp(contestGrpId=null){
			if(!contestGrpId){
				contestGrpId = localStorage.getItem("contestType");
			}

			if(contestGrpId){
				return (window.all_contests.includes(contestGrpId)) ? contestGrpId : window.default_contest;
			}
			
			return window.default_contest;			
		}

		/**
		* VERY IMPORTANT: The config comes from core_maintenance.js
		* window.all_contests - list of contestGrpIds 
		* window.default_contest - default contest group
		*/
		getContestGroupIds(){
			let routeArr = [];
			if(window.all_contests && window.all_contests.length > 0){
				window.all_contests.map((route, idx) => {
					if(route && route.includes("/")){
						routeArr.push(route);
					}else if(route){
						routeArr.push("/"+route);
					}	
				});
			}else{
				if(window.default_contest){
					if(window.default_contest.includes("/")){
						routeArr.push(window.default_contest);
					}else{
						routeArr.push("/"+window.default_contest);
					}
				}else{
					routeArr.push("/");
				}
			}

			return routeArr;
		}

		goToInstructions(){
			//defaulting to ri
			const contestGrp = (window.contest_host_groups && window.contest_host_groups[this.getContestHost()]) ? window.contest_host_groups[this.getContestHost()] : "ri";
		
			return this.getCmpHelper().getCmp(contestGrp+"_ContestInstruction", "ri_ContestInstruction");
		}

		goToDefaultContest(){
			return "/"+window.default_contest;
		}

		getSwitcher(){
			return(

				<Switch>
				{/*<Redirect exact path='/' exact to={"/"+(this.getValidContestGrp(localStorage.getItem("contestType")))} />*/}
				<Redirect exact path='/' exact to={this.goToDefaultContest()} />

				<Redirect path='/reg' exact to={"/"+(this.getValidContestGrp(localStorage.getItem("contestType")))} />
				<Route path='/RI23' exact component={this.RIRegistration} maintainScrollPosition={true} />

				<Route path={this.getContestGroupIds()} exact component={this.RIRegistration} maintainScrollPosition={true} />

				<Route path="/contest/settings" exact component={()=> <ContestProfileSettings userNameUpdateEvent={this.userNameUpdateEvent}  callbackHomeUpdateImage={this.UpdateProfileImage}/>}/>

				<Route path="/contest/take" exact component={ContestLayout}/>

				<Route path="/contest/report" exact component={ContestReport} />

				<Redirect from="/contest/upload" exact to={this.contestPreModel("/contest/upload")} />
				<Route path="/contest/upload/:contestGrpId?" exact component={ContestHome}/>

				<Redirect from="/contest/faq" exact to={this.contestPreModel("/contest/faq")} />
				<Route path="/contest/faq/:contestGrpId?" exact component={ContestFaq}/>

				<Redirect from="/registration" exact to={this.contestPreModel("/registration")} />
				<Route path="/registration/:contestGrpId?" exact component={Registration} />

				<Redirect from="/trail" exact to={this.contestPreModel("/trail")} />
				<Route path="/trail/:contestGrpId?" exact component={ContestSteps}/>

				<Redirect from="/contest/schoolreport" exact to={this.contestPreModel("/contest/schoolreport")} />
				<Route path="/contest/schoolreport/:contestGrpId?" exact component={SchoolReport} />

				<Redirect from="/resource" exact to={this.contestPreModel("/resource")} />
				<Route path="/resource/:contestGrpId?" exact component={ContestDownloads} />

				<Redirect from="/contest/instruction" exact to={this.contestPreModel("/contest/instruction")} />
				<Route path="/contest/instruction/:contestGrpId?" exact component={this.goToInstructions()}/>
				

				<Redirect from='*' to={this.contestPreModel("/")} />
				</Switch>
				)
			}

			isHeaderMenuAllowed(headerMenu){
				let menuAllowed = true;

				if(headerMenu && window.header_suppression_for_school &&  window.header_suppression_for_school[this.getSchoolId()] && window.header_suppression_for_school[this.getSchoolId()].length > 0){
					this.suppressedHeaders = window.header_suppression_for_school[this.getSchoolId()] || [];
					menuAllowed = (this.suppressedHeaders.indexOf(headerMenu) === -1);
				}

				if(headerMenu && window.header_suppression_for_entl){
					let suppressMenus = (window.header_suppression_for_entl[headerMenu]) ? window.header_suppression_for_entl[headerMenu] : window.header_suppression_for_entl["all"];

					if(suppressMenus && suppressMenus.length > 0){
						let userEntitlement = Object.keys(this.getUser().getPermissions());
						let accessMap = this.getUser().getAccessMap();

						if(userEntitlement && userEntitlement.length > 0){
							for(let i=0; i < userEntitlement.length; i++){
								if(suppressMenus.includes(accessMap[userEntitlement[i]])){
									menuAllowed = false;
									break;
								}			
							}
						}
					}
				}

				return menuAllowed;
			}

			getHeaderLogo(){
				return(
				<img src="/img/hm_logo.png" alt="Heymath! logo"/>
				)
			}

			isHeaderAvailableFn(){
				let isHeaderAvailable = true;
				//Hardcoding for Contest
				if(!this.state.PLPloggedIn && !this.state.loggedIn){
					isHeaderAvailable = false;
				}


				if(window.headerless_components && window.headerless_components.length > 0){
					isHeaderAvailable = !window.headerless_components.includes(this.selectedCompName);
				}

				this.setState({isHeaderAvailable:isHeaderAvailable});
	//console.log("isHeaderAvailable ",isHeaderAvailable," : ",this.selectedCompName);
}

showHideLeftMenu(){
	//$(".page-content nav.side-navbar").toggle();
	$(".page-content .content-inner").toggleClass("fullwidth");
	$(".page-content nav.side-navbar").toggle('normal');
	$(".page-content nav.side-navbar").toggleClass('animatecollapsed');

	try{
		var isCollapsed = $('nav.side-navbar').hasClass('animatecollapsed');


		if(typeof isCollapsed === "boolean"){
			this.setAttribute("sidebar_collapsed",isCollapsed.toString());	
		} 
		

		sidebar_props.collapsed =  $('nav.side-navbar').hasClass('animatecollapsed');
		UserStorageUtil.storeSessionItem("sidebar_collapsed",sidebar_props.collapsed);
	}catch(e){
		//console.log(e);
	}
	
	
}

getRIImgFn = () =>{
	let contestHost = this.getContestHost();
	let riLogoArr = window.RILogo || [];
	if(riLogoArr.indexOf(contestHost) > -1){
		return true;
	}
	return false;
}

getHeader(){
	let me = this;
	if(this.state.isHeaderAvailable){
		return(
			<div>
			<header className="clearfix">
			<nav className="nav-desktop prep-desktop">
			<div className="container-fluid norightpadding">

			<div className="showhidemenu">
			<a id="toggle-btn" href="#" className="menu-btn active" onClick={this.showHideLeftMenu}>
			<i className="material-icons">menu</i>
			</a>
			</div>

			{(()=>{
				if(me.isHeaderMenuAllowed("hm_logo_click")){
					return(<div className="logo">
						<Link to="/home" onClick={me.setPreloginClass}>
							{
								(()=>{
									if(me.getRIImgFn()){
										return(
											<img className="ri-img" src="/img/ri200_logo.png" alt="Raffles Institution"/>
										)
									}
								})()
							}
							{me.getHeaderLogo()}
						</Link></div>);
				}else{
					return(<div className="logo">
						{
							(()=>{
								if(me.getRIImgFn()){
									return(
										<img className="ri-img" src="/img/ri200_logo.png" alt="Raffles Institution"/>
									)
								}
							})()
						}
						
						{me.getHeaderLogo()}
					</div>);
				}
			})()}

			{( () => {
				if(me.state.LumosloggedIn || me.state.loggedIn || me.state.PLPloggedIn){
					return (<ul className="textAlignLeft"><span></span></ul>);
				}
			})()}


			<div className="r-sec">
			{(() => {
				if(me.isHeaderMenuAllowed("my_heymath")){
					return (<a className={"r-btn myheymathbtn mr-30 "+me.getMargin()} onClick={me.showLoginForm}>{me.getButtonName()}</a>);
				}else{
					return (<span></span>);						
				}
			})()}

			{me.renderLoginView()}                 	
			</div>


			</div>
			</nav>


			</header>
			<div className="clearfix"></div>
			{me.getSwitcher()}

			</div>
			)
		}else{
			return(
			<div>
			{me.getSwitcher()}
			</div>
			)
		}
	}

	getRouter(){
		var me=this;

		return(
		<Router>
		{me.getHeader()}
		</Router>
		)
	}

	render() {
		var isMenuOpen = function(state) {
			return state.isOpen;
		};
		const {grades,products_details,products_class,products_classification,products_category} = this.state;
		return (
		<div className={"App "+this.state.preloginClassName}>

		{this.getRouter()}
		<div>							
		<TestTakingModalComponent visible={this.state.ModalShow} dialogClassName={"loginModal modal-lg "+this.state.customClass}>

		<div data-p-ga="" className="modal-body">
		<div className="close loginClose" onClick={this.hideLoginModal} aria-label="Close">
		<span aria-hidden="true"><i className="material-icons">close</i></span>
		</div>
		{this.state.ModalContent}
		</div>							
		</TestTakingModalComponent>
		</div>	
		<div>							
		<TestTakingModalComponent visible={this.state.HelpModalShow} dialogClassName={"loginModal modal-lg "+this.state.customClass}>
		<div className="loginHeader text-center">	
		<div className="text-center modallogo">
		<div><div className="text-center loginHeaderTxt josefinsansFont">{this.rb("resetpwd.instruction")}</div></div>
		</div>
		<div className="close helpClose"  onClick={this.hideHelpLoginModal} aria-label="Close">
		<span aria-hidden="true"><i className="material-icons">close</i></span>
		</div>
		</div>
		<div className="modal-body">
		{this.state.HelpModalContent}
		</div>							
		</TestTakingModalComponent>
		</div>

		</div>
		);
	}
}


export default PreloginHome;

ComponentRegistry.register("PreloginHome",PreloginHome);


// WEBPACK FOOTER //
// ./src/views/common/PreloginHome.js